import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";
import { CATEGORY_META } from "@/data/categories";

export const CategoryCard = ({ category, count }) => {
  const { tc, t } = useLang();
  const meta = CATEGORY_META[category] || {};
  const Icon = meta.icon;

  return (
    <Link
      to={`/browse?category=${category}`}
      data-testid={`category-card-${category}`}
      className="cat-card group hover-lift"
    >
      <img src={meta.image} alt={tc(category)} loading="lazy" className="cat-card-img" />
      <span className="cat-card-veil" aria-hidden="true" />
      <div className="relative flex h-full flex-col justify-between p-4">
        <div className="flex items-start justify-between gap-2">
          <span className="glass-pill flex items-center gap-2">
            {Icon && <Icon className="h-4 w-4" style={{ color: "#c6bff0" }} />}
            <span className="text-[13px] font-medium text-ppc-text">{tc(category)}</span>
          </span>
          {count > 0 && (
            <span className="glass-pill text-[11.5px] text-ppc-text" data-testid={`category-count-${category}`}>
              {count}
            </span>
          )}
        </div>
        <span className="glass-pill flex w-fit items-center gap-1.5 text-[12px] text-ppc-text transition-colors group-hover:text-primary-green">
          {t("hero_cta")}
          <ArrowUpRight size={13} weight="bold" />
        </span>
      </div>
    </Link>
  );
};
